export default "__VITE_ASSET__vZXfsvYy__"